import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface LocationState {
  latitude: number;
  longitude: number;
  // Whether latitude/longitude come from an actual GPS/Telegram fix, as
  // opposed to still being the Tashkent fallback center below.
  hasFix: boolean;
}
const LAT_CENTER = 41.32018670575328;
const LNG_CENTER = 69.26235777157218;

const storedLocation = sessionStorage.getItem('location');

const initialState: LocationState = {
  latitude: storedLocation ? JSON.parse(storedLocation).latitude : LAT_CENTER,
  longitude: storedLocation ? JSON.parse(storedLocation).longitude : LNG_CENTER,
  hasFix: storedLocation ? !!JSON.parse(storedLocation).hasFix : false,
};

export const locationSlice = createSlice({
  name: 'location',
  initialState,
  reducers: {
    setLocation: (
      state,
      action: PayloadAction<Pick<LocationState, 'latitude' | 'longitude'>>
    ) => {
      state.latitude = action.payload.latitude;
      state.longitude = action.payload.longitude;
      state.hasFix = true;

      sessionStorage.setItem('location', JSON.stringify(state));
    },
  },
});

export const { setLocation } = locationSlice.actions;
export default locationSlice.reducer;
